import { defineNuxtRouteMiddleware, navigateTo } from "nuxt/app";
import { getQueryParamValue } from "@chatfood/core-utils";
import { isClient } from "@/utils/is-client";
import { useBasketStore } from "#imports";

export default defineNuxtRouteMiddleware(async (to) => {
  if (!isClient()) return;

  const QUERY_ID = "loyalty-program-id";
  const loyaltyProgramId = getQueryParamValue(to.query, QUERY_ID);

  if (!loyaltyProgramId) return;

  const basketStore = useBasketStore();

  if (!basketStore.isLoaded) {
    basketStore.addPendingAction({
      type: "addLoyaltyProgram",
      loyaltyProgramId,
    });
  } else {
    if (basketStore.discount) {
      await basketStore.removeDiscount();
    }

    try {
      await basketStore.applyLoyalty(loyaltyProgramId);
    } catch {
      // Knowing this is an user input which the system can't properly validate
      // the process will fail silently due to the many flaky reasons
      // like invalid id, basket not elegible, etc
    }
  }

  const { [QUERY_ID]: _, ...cleanQuery } = to.query;

  return navigateTo(
    {
      path: to.path,
      query: cleanQuery,
      hash: to.hash,
    },
    { replace: true },
  );
});
